var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-_qgptx3l71-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-_qgptx3l71-2",
    x: 0,
    y: 0,
    width: 39,
    height: 39,
    rx: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-68.4%",
    y: "-104.0%",
    width: "236.8%",
    height: "307.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-_qgptx3l71-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.77635684e-13%",
    y1: "42.3540893%",
    x2: "47.7727725%",
    y2: "46.9538638%",
    id: "linearGradient-_qgptx3l71-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.853553185%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-_qgptx3l71-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin-Updates-October-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-Notification",
    transform: "translate(-803.000000, -740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(650.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image-Drop-Copy-2",
    transform: "translate(30.000000, 556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(108.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-(?)",
    transform: "translate(15.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-_qgptx3l71-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-_qgptx3l71-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-Copy-5",
    fill: "url(#linearGradient-_qgptx3l71-1)",
    xlinkHref: "#path-_qgptx3l71-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "swiftfill-copy",
    mask: "url(#mask-_qgptx3l71-3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.850000, 10.335000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-_qgptx3l71-4)",
    transform: "translate(13.625890, 9.750000) rotate(-6.204938) translate(-13.625890, -9.750000) translate(0.834793, 1.333218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92994418,11.8859919 C4.92994418,11.8859919 6.41591533,12.4206988 8.35199689,12.5365282 C11.0978726,12.7007239 12.8058649,14.4567256 12.8058649,14.4567256 C9.50535275,14.4115718 6.84306213,15.1135679 4.92994418,11.8859919 Z M11.3058141,6.90869497e-15 L19.3792381,7.54367714 L17.680991,13.7378175 C17.680991,13.7378175 17.158383,9.98272802 9.60253299,8.66568265 C1.37845868,7.23203437 -1.94161633e-15,1.12584956 -1.94161633e-15,1.12584956 C5.34707609,2.40363069 11.3058141,6.90869497e-15 11.3058141,6.90869497e-15 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-_qgptx3l71-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1663842,0.223260797 C12.4764334,-0.0150325658 12.9120015,0.00028246832 13.2044865,0.259674164 C14.2258815,1.16272568 15.438875,1.79663958 16.8941246,2.09030268 C17.0608764,2.1238244 17.2321263,2.12896511 17.4005917,2.10529642 C18.0279726,2.01726175 19.7345814,1.77768321 20.7743973,1.63170844 C20.9499311,1.60707587 21.1253579,1.67722515 21.2355619,1.81613144 C21.3457659,1.95503773 21.3740398,2.14192398 21.3101022,2.30728351 C21.0160107,3.06693062 20.5855833,4.17850222 20.3661392,4.74612236 C20.2729638,4.98698608 20.3170882,5.24777005 20.2798181,5.50319912 C19.839966,8.52433056 26.2003104,14.9310484 25.533089,16.3261088 C24.8657604,17.7211692 18.1638801,16.0216288 16.2760612,13.8735614 C15.9655837,13.5203517 15.5710341,13.1129504 15.1219716,12.6695641 C14.8107444,12.3622995 14.4495024,12.0193713 14.1823996,11.7612648 C13.5665853,11.1754379 12.8988284,10.5537332 12.2324638,9.92892267 C11.3935641,9.1210814 11.1789394,8.91438199 9.72015562,7.50957568 C9.31971567,7.10442342 8.95429682,6.71876301 8.64221283,6.36362558 C8.49120446,6.19184016 8.384856,5.99231633 8.32488104,5.78133299 C8.43883347,3.71198272 11.4818129,0.747399096 12.1663842,0.223260797 Z",
    id: "SVGID_2_",
    fill: "url(#linearGradient-_qgptx3l71-6)",
    fillRule: "nonzero"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLogo);
export default __webpack_public_path__ + "static/media/purple-logo.3af98750f3f6dc11433b5336891c11e5.svg";
export { ForwardRef as ReactComponent };